import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { PremiumBannerPage } from "./premium-banner/premium-banner";
import { PremiumPaymentPage } from "./premium-payment/premium-payment";
const routes: Routes = [
    { path: 'banner', loadComponent: () =>
      import('./premium-banner/premium-banner').then(m => m.PremiumBannerPage)
    },
    { path: 'payment', loadComponent: () =>
      import('./premium-payment/premium-payment').then(m => m.PremiumPaymentPage)
    }
  ];
@NgModule({
    declarations: [
      PremiumBannerPage,
      PremiumPaymentPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        SharedModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class PremiumModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }